import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import '@/js/bootstrap';
import '@/js/recaptcha';
import '@/js/helpers/setDynamicVH';

import Translate from '@/js/helpers/Translate.vue';
import { sentryErrorsIgnoreList } from '@/js/constants';
import { VITE_APP_ENV, VITE_SENTRY_DSN } from '@/js/helpers/environment';

// -- multiple imports in other components (AuthModal)
const AuthPageWrapper = defineAsyncComponent(() => import('@/js/auth/AuthPageWrapper.vue'));
const WalletPromoSlider = defineAsyncComponent(() => import('@/js/auth/WalletPromoSlider.vue'));

const app = createApp({});

app.use(createPinia());
app.use(VueToast);

// Helpers
app.component('Translate', Translate);
app.config.globalProperties.Translate = Translate.methods;

app.component('AuthPageWrapper', AuthPageWrapper);
app.component('WalletPromoSlider', WalletPromoSlider);

Sentry.init({
    app,
    dsn: VITE_SENTRY_DSN,
    environment: VITE_APP_ENV,
    ignoreErrors: sentryErrorsIgnoreList,
    denyUrls: [/^chrome-extension:\/\//i],
});

app.mount('#auth-mount');
